var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner app-main-inner-row" },
    [
      _c(
        "el-form",
        {
          staticClass: "section",
          staticStyle: { width: "650px" },
          attrs: { "label-width": "100px", "label-position": "left" }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c("div", {
                    staticStyle: {
                      "background-color": "#57D1FF",
                      width: "12px",
                      height: "30px",
                      "margin-right": "5px"
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticStyle: { "font-width": "bold", "font-size": "15px" }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.importSetting")))]
                  )
                ])
              ])
            ],
            1
          ),
          _vm.isFinance
            ? _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "1" },
                          on: { change: _vm.bussinessType_changeHandler },
                          model: {
                            value: _vm.bussinessType,
                            callback: function($$v) {
                              _vm.bussinessType = $$v
                            },
                            expression: "bussinessType"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { label: "SE", value: "SE" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_OceanExport"))
                              )
                            ]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { label: "SI", value: "SI" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_OceanImport"))
                              )
                            ]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { label: "AE", value: "AE" } },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AirExport")))]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { label: "AI", value: "AI" } },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AirImport")))]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { label: "RE", value: "RE" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_RailwayExport"))
                              )
                            ]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { label: "RI", value: "RI" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_RailwayImport"))
                              )
                            ]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { label: "IE", value: "IE" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_IntegratedJob"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.noRule") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "2",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.noRule,
                            callback: function($$v) {
                              _vm.noRule = $$v
                            },
                            expression: "noRule"
                          }
                        },
                        _vm._l(_vm.noRuleList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { no: "3" },
                      model: {
                        value: _vm.accountType,
                        callback: function($$v) {
                          _vm.accountType = $$v
                        },
                        expression: "accountType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.receivable")))
                      ]),
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.payable")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TaxRate") } },
                    [
                      _c("el-input-number", {
                        attrs: { no: "4", controls: false, min: 0 },
                        model: {
                          value: _vm.txtTaxRate,
                          callback: function($$v) {
                            _vm.txtTaxRate = $$v
                          },
                          expression: "txtTaxRate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.lob === "RE" && !_vm.isFinance
                ? _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "5" },
                          model: {
                            value: _vm.railwayType,
                            callback: function($$v) {
                              _vm.railwayType = $$v
                            },
                            expression: "railwayType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: "RE" } }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Export")))
                          ]),
                          _c("el-radio", { attrs: { label: "RI" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_JobTypeImport"))
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c("div", {
                    staticStyle: {
                      "background-color": "#57D1FF",
                      width: "12px",
                      height: "30px",
                      "margin-right": "5px"
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticStyle: { "font-width": "bold", "font-size": "15px" }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.importFile")))]
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FileName") } },
                    [
                      _c("el-input", {
                        ref: "txtFileName",
                        attrs: { no: "6", readonly: true },
                        model: {
                          value: _vm.txtFileName,
                          callback: function($$v) {
                            _vm.txtFileName = $$v
                          },
                          expression: "txtFileName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-col", { attrs: { span: 10 } }, [
                _c(
                  "div",
                  { staticStyle: { flex: "1" } },
                  [
                    _c(
                      "el-upload",
                      {
                        ref: "upload",
                        staticStyle: { display: "inline-block" },
                        attrs: {
                          data: { uploadSetting: _vm.uploadSetting },
                          accept: ".xls",
                          multiple: false,
                          action: _vm.URL.act.charge.importExcelCharge,
                          headers: {
                            sessionId: _vm.sessionId,
                            language: _vm.language
                          },
                          "auto-upload": false,
                          "show-file-list": false,
                          "on-success": _vm.uploadExcelSuccess,
                          "on-error": _vm.uploadExcelError,
                          "on-change": _vm.handleChange
                        }
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { type: "primary", no: "7" } },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.SelectFile")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { type: "primary", no: "8" },
                        on: { click: _vm.downloadTemplate }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.TemplateDownload")))]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c("el-col", { attrs: { span: 14 } }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "50" },
                        model: {
                          value: _vm.onlyImportedCurrentBranch,
                          callback: function($$v) {
                            _vm.onlyImportedCurrentBranch = $$v
                          },
                          expression: "onlyImportedCurrentBranch"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_OnlyImportedCurrentBranch")
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm.isFinance
            ? _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 14 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.importExpenseStatus")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "9",
                                placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                size: "mini"
                              },
                              model: {
                                value: _vm.importExpenseStatus,
                                callback: function($$v) {
                                  _vm.importExpenseStatus = $$v
                                },
                                expression: "importExpenseStatus"
                              }
                            },
                            _vm._l(_vm.importExpenseStatusList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isFinance
            ? _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 14 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.accountingDate") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "195px" },
                            attrs: {
                              type: "date",
                              no: "10",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.accountingDate,
                              callback: function($$v) {
                                _vm.accountingDate = $$v
                              },
                              expression: "accountingDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "11" },
                      on: { click: _vm.importFileBtnClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.confirmImport")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.importResultWindow.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.importResultWindow.visible,
                title: _vm.importResultWindow.title,
                width: "400px",
                "close-on-click-modal": false,
                "destroy-on-close": true
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.importResultWindow, "visible", $event)
                },
                close: _vm.closeHandler
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "text-align": "center"
                  }
                },
                [
                  _c("span", { staticStyle: { "line-height": "40px" } }, [
                    _vm._v(_vm._s(_vm.importResultWindow.content))
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "30px" },
                      attrs: { type: "primary", no: "12" },
                      on: {
                        click: function($event) {
                          return _vm.continueImporting()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ContinueImporting")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "30px" },
                      attrs: {
                        disabled: !_vm.importResultWindow.downLoadDocumentId,
                        type: "primary",
                        no: "13"
                      },
                      on: {
                        click: function($event) {
                          return _vm.downloadResultLog()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.DownloadResultLog")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }